import API from '../../services/API';
import { setError, startSpinner, stopSpinner } from '../common/actionCreators';
import { configs } from '../../constants/configs/configs';

const actions = { setError, startSpinner, stopSpinner };
const { endpoints } = configs;


/************************

 # Async action creators

 ************************/


/************************

 # GET calls

 ************************/


export const getIvrData = (refId) => async dispatch => {

    const url = endpoints.GET_IVR_DATA.processReplacements({ refId });
    const data = await API.getData(url, dispatch, actions);

    if (data) {
        return data;
    }
};

export const getScreenpopAssisterData = ({ body }) => async dispatch => {

    const params = [ endpoints.SCREENPOP_ASSISTER_DATA, body ];

    const data = await API.postData(params, dispatch, actions);

    if(data) {
        return data;
    }
};

export const getScreenpopBrokerData = ({ body }) => async dispatch => {

    const params = [ endpoints.SCREENPOP_BROKER_DATA, body ];

    const data = await API.postData(params, dispatch, actions);


    if(data) {
        return data;
    }
};

export const getCountiesData = () => async dispatch => {
    const url = endpoints.GET_SCREENPOP_COUNTIES;

    const data = await API.getData(url, dispatch, actions);

    if(data) {
        return data;
    }
};


/************************

 # POST calls

 ************************/


export const getApplicants = (...args) => async dispatch => {
    let [ body ] = args;
    const params = [ endpoints.SEARCH_APPLICANT, body ];

    const data = await API.postData(params, dispatch, actions);

    if (data) {
        if(data.applicants) {
            return data.applicants;
        }
        return data;
    }
};

export const postLogData = (...args) => async dispatch => {
    let [ url, body ] = args;
    const params = [ url, body ];

    const data = await API.postData(params, dispatch, actions);

    if (data) {
        return data;
    }
};
